import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Input,
  Spinner
} from "reactstrap";
import axios from "axios";
import { postDataAPI } from "../../helpers/phpbackend_helper";

const RecordDescriptionModal = ({ isOpen, onClose, onSave, dishName }) => {
  const mediaRecorderRef = useRef(null);
  const chunksRef = useRef([]);

  const [recording, setRecording] = useState(false);
  const [loading, setLoading] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [textInput, setTextInput] = useState("");

  /* ⏱ Timer */
  useEffect(() => {
    let timer;
    if (recording) {
      timer = setInterval(() => setSeconds((s) => s + 1), 1000);
    }
    return () => clearInterval(timer);
  }, [recording]);

  const formatTime = () => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s.toString().padStart(2, "0")}`;
  };

  /* 🎙 Start recording */
  const startRecording = async () => {
    try {
      if (!navigator.mediaDevices) {
        alert("Microphone not supported");
        return;
      }

      setTextInput("");
      setSeconds(0);
      chunksRef.current = [];

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);

      mediaRecorderRef.current = recorder;
      setRecording(true);

      recorder.ondataavailable = (e) => {
        if (e.data.size > 0) chunksRef.current.push(e.data);
      };

      recorder.onstop = async () => {
        const blob = new Blob(chunksRef.current, { type: "audio/webm" });
        // const formData = new FormData();
        // formData.append("audio", blob, "record.webm");

        try {
          setLoading(true);
          // const res = await axios.post(
          //   "http://localhost/elevenlabs/api/voice-transcribe.php",
          //   formData
          // );         
          // setTextInput(res.data.text || "");
          postDataAPI({
            serviceName: "server_data",
            op: "agent_voice_transcribe",
            audio: blob
          })
            .then((res) => {
              console.log(res);
              
              if (res.status === "ok" && res.data.http === 200) {
                setTextInput(JSON.parse(res.data.resp).text || "");
              }
            })
            .finally(() => setLoading(false));
        } catch (err) {
          console.error(err);
          alert("Transcription failed");
        } finally {
          setLoading(false);
        }
      };

      recorder.start();
    } catch (err) {
      console.error(err);
      alert("Microphone access denied");
    }
  };

  /* ⏹ Stop recording */
  const stopRecording = () => {
    if (mediaRecorderRef.current && recording) {
      mediaRecorderRef.current.stop();
      setRecording(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      // Reset everything when modal opens
      setSeconds(0);
      setRecording(false);
      setTextInput("");
      setLoading(false);
      chunksRef.current = [];

      // Safety: stop recorder if still active
      if (mediaRecorderRef.current) {
        try {
          mediaRecorderRef.current.stop();
        } catch (e) {console.log(e);
        }
        mediaRecorderRef.current = null;
      }
    }
  }, [isOpen]);


  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>
        <i className="ri-mic-line text-danger me-2" />
        Record Description for {dishName}
      </ModalHeader>

      <ModalBody className="text-center">
        <h4 className="text-muted mb-3">{formatTime()}</h4>

        {/* Mic Button */}
        <Button
          color="info"
          className="rounded-circle mb-3"
          style={{ width: 72, height: 72 }}
          onClick={recording ? stopRecording : startRecording}
          disabled={loading}
        >
          {loading ? (
            <Spinner size="sm" />
          ) : (
            <i
              className={`ri-${recording ? "stop-fill" : "mic-fill"} fs-3`}
            />
          )}
        </Button>

        {/* Transcript */}
        {textInput && (
          <>
            <div className="text-start mt-3">
              <label className="text-muted small mb-1">
                Transcript (edit if needed)
              </label>
              <Input
                type="textarea"
                rows="4"
                value={textInput}
                onChange={(e) => setTextInput(e.target.value)}
              />
            </div>
            <br />
            <div className="d-flex justify-content-between mt-3">
              <Button outline onClick={startRecording}>
                Edit Recording
              </Button>
              <Button color="primary" onClick={() => onSave(textInput)}>
                <i className="ri-save-line me-1" /> Save
              </Button>
            </div>
          </>
        )}
        
        {!textInput && !recording && !loading && (
          <Button color="light" className="mt-3 w-100" onClick={onClose}>
            Cancel
          </Button>
        )}
      </ModalBody>
    </Modal>
  );
};

export default RecordDescriptionModal;
